import DashboardLayout from '../views/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import Auth from '../views/GeneralViews/Auth.vue'
import NotFound from '../views/GeneralViews/NotFoundPage.vue'
import Dashboard from '../views/Dashboard/common/Dashboard/Dashboard.vue'

// General section
import Ips from '../views/Dashboard/common/General/Ips.vue'
import GlobalSettings from '../views/Dashboard/common/General/GlobalSettings.vue'
import MonitoringStatus from '../views/Dashboard/common/General/MonitoringStatus.vue'
import ProxyServers from '../views/Dashboard/common/General/ProxyServers.vue'
import UserManagment from '../views/Dashboard/common/General/UserManagment.vue'
import Servers from '../views/Dashboard/common/General/Servers.vue'
import Ooooor from '../views/Dashboard/common/General/Ooooor.vue'
import Tasks from '../views/Dashboard/common/General/Tasks.vue'
import Notification from '../views/Dashboard/common/General/Notification.vue'

import Clients from '../views/Dashboard/common/General/Clients.vue'
import Supports from '../views/Dashboard/common/General/Supports.vue'
import Utilities from '../views/Dashboard/common/General/Utilities.vue'

import ModelsList from '../views/Dashboard/common/General/ModelsList.vue'

// Device section
import Device from '../views/Dashboard/common/Device/Device.vue'
import DeviceGroups from '../views/Dashboard/common/Device/DeviceGroups.vue'
import DeviceList from '../views/Dashboard/common/Device/DeviceList.vue'
import DeviceGroupList from '../views/Dashboard/common/Device/DeviceGroupList.vue'
import SimCardDevices from '../views/Dashboard/common/Device/SimCardDevices.vue'
import SimCardDevicesList from '../views/Dashboard/common/Device/SimCardDevicesList.vue'
import SimCardDevicesGroupList from '../views/Dashboard/common/Device/SimCardDevicesGroupList.vue'
import SimCardDevicesGroup from '../views/Dashboard/common/Device/SimCardDevicesGroup.vue'

// Old SimcardProfile section
import CommunicationManagement from '../views/Dashboard/common/Communication/CommunicationManagement/CommunicationManagement.vue'

import CompanyServices from '../views/Dashboard/common/General/CompanyServices.vue'

// SimcardProfile section
import SimCardProfile from '../views/Dashboard/common/Communication/SimCardProfile/SimCardProfile.vue'
import SimCardProfileGroup from '../views/Dashboard/common/Communication/SimCardProfile/SimCardProfileGroup.vue'
import SimCardProfileList from '../views/Dashboard/common/Communication/SimCardProfile/SimCardProfileList.vue'
import SimCardProfileGroupList from '../views/Dashboard/common/Communication/SimCardProfile/SimCardProfileGroupList.vue'

//EsimProfile section
import EsimProfile from '../views/Dashboard/common/Communication/EsimProfile/EsimProfile.vue'
import EsimProfileGroup from '../views/Dashboard/common/Communication/EsimProfile/EsimProfileGroup.vue'
import EsimProfileList from '../views/Dashboard/common/Communication/EsimProfile/EsimProfileList.vue'
import EsimProfileGroupList from '../views/Dashboard/common/Communication/EsimProfile/EsimProfileGroupList.vue'

//CustomDeviceList
import CustomDeviceList from '../views/Dashboard/common/Device/CustomDeviceList.vue'


const MyRoute = {
  def: function() {
    return [
      { path: '/auth', name: 'auth', component: Auth },
      { path: '/notfound', component: NotFound, name: 'notfound' },
      { path: '*', component: NotFound },
      {
        path: '/',
        redirect: '/device_list'
      },
    ]
  },


  user: function() {
    const userPath = [
      {
        path: '/modem',
        redirect: '/device'
      },
      {
        path: '/modem/:device_id',
        redirect: '/device/:device_id'
      },
      {
        path: '/modem/:device_id/:device_section',
        redirect: '/device/:device_id/:device_section'
      },
      {
        path: '/modem_list',
        redirect: '/device_list'
      },
      {
        path: '/modem_groups/:device_group_id',
        redirect: '/device_groups/:device_group_id'
      },
      //Redirect_END

      {
        path: '/device/:device_id',
        name: 'device',
        redirect: '/device/:device_id/profile',
        access_list: [],
        component: Device,
        children: [
          {
            name: 'device_section',
            path: '/device/:device_id/:device_section',
            props: true,
            component: Device
          },
          {
            name: 'device_section_zero',
            path: ':device_section/:to_zero',
            component: Device
          }
        ]
      },
      {
        path: '/device_list',
        name: 'device_list',
        component: DeviceList
      },
      {
        path: '/device_group/:device_group_id',
        name: 'device_list_group',
        component: DeviceGroupList
      },
      {
        path: '/device_groups',
        name: 'device_groups',
        component: DeviceGroups
      },

      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard
      },
      {
        path: '/servers',
        name: 'servers',
        redirect: '/servers/all',
        component: Servers,
        children: [
          {
            name: 'servers_section',
            path: '/servers/:servers_section',
            component: Servers
          }
        ]
      },
      {
        path: '/supports',
        name: 'supports',
        component: Supports,
        children: [
          {
            path: '/supports/:support_id',
            name: 'support_item',
            component: Supports
          }
        ]
      },
      {
        path: '/custom_device_list',
        name: 'custom_device_list',
        component: CustomDeviceList
      },
      {
        path: '/tasks',
        name: 'tasks',
        component: Tasks
      },
      {
        path: '/ooooor',
        name: 'ooooor',
        component: Ooooor
      },
      {
        path: '/models_list',
        name: 'models_list',
        component: ModelsList
      },
      {
        path: '/usermanagment',
        name: 'usermanagment',
        redirect: '/usermanagment/users',
        component: UserManagment,
        children: [
          {
            name: 'usermanagment_section',
            path: '/usermanagment/:usermanagment_section',
            component: UserManagment,
            children: [
              {
                name: 'usermanagment_section_id',
                path: '/usermanagment/:usermanagment_section/:user_id',
                component: UserManagment
              }
            ]
          }
        ]
      },
      {
        path: '/ips',
        name: 'ips',
        redirect: '/ips/list',
        component: Ips,
        children: [
          {
            name: 'ips_section',
            path: '/ips/:ips_section',
            component: Ips
          },
        ]
      },
      {
        path: '/clients',
        name: 'clients',
        component: Clients,
        children: [
          {
            name: 'client_id',
            path: '/clients/:client_id',
            component: Clients
          }
        ]
      },
      {
        path: '/global_settings',
        name: 'global_settings',
        component: GlobalSettings
      },
      {
        path: '/monitoring_status',
        name: 'global_monitoring_status',
        component: MonitoringStatus
      },
      {
        path: '/utilities',
        name: 'utilities',
        component: Utilities
      },
      {
        path: '/proxy_servers',
        name: 'proxy_servers',
        component: ProxyServers
      },
      {
        path: '/notification',
        name: 'notification',
        redirect: '/notification/profiles',
        component: Notification,
        children: [
          {
            name: 'notification_section',
            path: '/notification/:notification_section',
            component: Notification
          }
        ]
      },
      {
        name: 'simcard_devices',
        path: '/simcard_devices/:simcard_devices_id',
        redirect: '/simcard_devices/:simcard_devices_id/profile',
        component: SimCardDevices,
        children: [
          {
            name: 'simcard_devices_section',
            path: '/simcard_devices/:simcard_devices_id/:simcard_devices_section',
            component: SimCardDevices
          }
        ]
      },
      {
        path: '/simcard_devices_list',
        name: 'simcard_devices_list',
        component: SimCardDevicesList
      },
      {
        path: '/simcard_devices_group/:simcard_devices_group_id',
        name: 'simcard_devices_group',
        component: SimCardDevicesGroup
      },
      {
        path: '/simcard_devices_group_list',
        name: 'simcard_devices_group_list',
        component: SimCardDevicesGroupList
      },


      //// Старый список с симкартами от операторов

      {
        path: '/communication_management',
        name: 'communication_management',
        redirect: '/communication_management/actions_history',
        component: CommunicationManagement,
        children: [
          {
            name: 'communication_management_section',
            path: '/communication_management/:communication_management_section',
            component: CommunicationManagement
          }
        ]
      },


      //// Тарифы и услуги

      {
        path: '/company_services',
        name: 'company_services',
        component: CompanyServices,
        children: [
          {
            name: 'company_services_section',
            path: '/company_services/:company_services_section',
            component: CompanyServices
          },
        ]
      },

      ////Cписок SimcardProfile

      {
        name: 'simcard_profile',
        path: '/simcard_profile/:simcard_profile_id',
        redirect: '/simcard_profile/:simcard_profile_id/profile',
        component: SimCardProfile,
        children: [
          {
            name: 'simcard_profile_section',
            path: '/simcard_profile/:simcard_profile_id/:simcard_profile_section',
            component: SimCardProfile
          }
        ]
      },
      {
        path: '/simcard_profile_list',
        name: 'simcard_profile_list',
        component: SimCardProfileList
      },
      {
        path: '/simcard_profile_group/:simcard_profile_group_id',
        name: 'simcard_profile_group',
        component: SimCardProfileGroup
      },
      {
        path: '/simcard_profile_group_list',
        name: 'simcard_profile_group_list',
        component: SimCardProfileGroupList
      },

      ////Cписок EsimProfile
      {
        name: 'esim_profile',
        path: '/esim_profile/:esim_profile_id',
        redirect: '/esim_profile/:esim_profile_id/profile',
        component: EsimProfile,
        children: [
          {
            name: 'esim_profile_section',
            path: '/esim_profile/:esim_profile_id/:esim_profile_section',
            component: EsimProfile
          }
        ]
      },
      {
        path: '/esim_profile_list',
        name: 'esim_profile_list',
        component: EsimProfileList
      },
      {
        path: '/esim_profile_group/:esim_profile_group_id',
        name: 'esim_profile_group',
        component: EsimProfileGroup
      },
      {
        path: '/esim_profile_group_list',
        name: 'esim_profile_group_list',
        component: EsimProfileGroupList
      },
    ]
    return {
      path: '/',
      component: DashboardLayout,
      children: userPath
    }
  }
}
export default {MyRoute}
